import { LocalStorageApi } from '@shared/lib';

export const themeStorage = new LocalStorageApi('theme');
